export class ClassBetween {

  constructor(
    public matrixClassId: number = null,
    public code: string = "",
    public period: number = 1,
    public startDateTime: Date = null,
    public endDateTime: Date = null,
    public date: Date = null,
  ) {}

  static clone(obj: any): ClassBetween {
    const cb = new this()

    if (obj.matrixClassId) { cb.matrixClassId = obj.matrixClassId }
    if (obj.code) { cb.code = obj.code }
    if (obj.period) { cb.period = obj.period }
    if (obj.startDateTime) { cb.startDateTime = new Date(obj.startDateTime) }
    if (obj.endDateTime) { cb.endDateTime = new Date(obj.endDateTime) }
    if (obj.date) { cb.date = new Date(obj.date) }

    return cb
  }
}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/class-between.ts